var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGridBoxes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 2800",
    style: {
      enableBackground: "new 0 0 1280 2800"
    },
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "box",
    x: 768.6,
    width: 255.2,
    height: "100%"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "box",
    x: 256.2,
    width: 511.4,
    height: "100%"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "box",
    x: 1024.8,
    width: 255.2,
    height: "100%"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "box",
    width: 255.2,
    height: "100%"
  }))));
}

export default SvgGridBoxes;